<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M512 192C529.7 192 544 206.3 544 224L544 416C544 433.7 529.7 448 512 448L384 448L384 192L512 192zM294.6 192L352 192L352 249.4L153.4 448L128 448C110.3 448 96 433.7 96 416L96 390.6L294.6 192zM249.3 192L96 345.4L96 224C96 206.3 110.3 192 128 192L249.4 192zM198.6 448L352 294.6L352 448L198.6 448zM128 160C92.7 160 64 188.7 64 224L64 416C64 451.3 92.7 480 128 480L512 480C547.3 480 576 451.3 576 416L576 224C576 188.7 547.3 160 512 160L128 160z"
      fill="currentColor"
    />
  </svg>
</template>